import React from 'react';
import { Grid, Modal, Button, Tooltip } from '@mui/material';
import { ArrowBackSharp, LogoutSharp } from '@mui/icons-material';

import styles from './ChatHeader.module.css';
import { useState } from 'react';

const ChatHeader = ({ status, handleLogOut, setStatus }) => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const handleClass = () => {
    var headerClass = styles.header;

    if (status === 0)
      headerClass = styles.headerError;

    if (status === 2)
      headerClass = styles.headerOffline;

    return headerClass;
  }

  const handleConfirmLogOut = () => {
    handleLogOut("byClient");
    setOpenConfirmModal(false);
  };

  return (
    <Grid container className={handleClass()} style={{ display: 'flex', alignItems: 'center' }}>
      <Grid item xs={11}>
        <h3>Atendimento Suporte Sysfar</h3>
      </Grid>
      <Grid item xs={1} className={styles.exitButton}>
        {(status !== 3 && status !== 4 && status !== 2) ? <Tooltip title="Encerrar chat"> <LogoutSharp fontSize="small" onClick={() => setOpenConfirmModal(true)} /> </Tooltip>
          : (status === 2) ? <Tooltip title="Voltar"> <ArrowBackSharp fontSize="small" onClick={() => setStatus(3)} /> </Tooltip> : <></>}
      </Grid>
      <Modal
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
      >
        <Grid sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '1.5rem 1.75rem',
          backgroundColor: 'var(--surface-elevated)',
          border: '1px solid var(--border)',
          borderRadius: '12px',
          textAlign: 'center',
          maxWidth: '20rem',
          boxShadow: 'var(--shadow-md)',
        }}>
          <p style={{ margin: '0 0 1.25rem', color: 'var(--text-primary)', fontSize: '0.9375rem', lineHeight: 1.5 }}>
            Tem certeza que deseja encerrar o atendimento?
          </p>
          <Button
            onClick={handleConfirmLogOut}
            variant="contained"
            disableElevation
            sx={{
              mr: 1,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '9999px',
              backgroundColor: 'var(--accent)',
              color: '#fafaf9',
              '&:hover': { backgroundColor: 'var(--accent-hover)' },
            }}
          >
            Sim
          </Button>
          <Button
            onClick={() => setOpenConfirmModal(false)}
            variant="outlined"
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '9999px',
              borderColor: 'var(--border-strong)',
              color: 'var(--text-secondary)',
              '&:hover': { borderColor: 'var(--text-muted)', backgroundColor: 'var(--surface-muted)' },
            }}
          >
            Não
          </Button>
        </Grid>
      </Modal>
    </Grid>
  );
};

export default ChatHeader;